function FailTitleDiv(props) {
    return (
      <>
        <div className={props.class} style={{backgroundColor: props.bgColor, color: props.fontColor}}>
            {props.title}
        </div>
      </>
    );
  }
  
export default FailTitleDiv;